export default {
  title01: "สภาพอากาศปัจจุบัน",
  title02: "24 ชั่วโมง",
  title03: "พยากรณ์อากาศใน 10 วัน",
  title04: "AQI",
  title05: "ดูข้อมูลทั้งหมด",
  title06: "ดวงอาทิตย์ขึ้นและดวงอาทิตย์ตก",
  title07: "ข้างขึ้นข้างแรมของดวงจันทร์",
  title08: "จันทร์เต็มดวง",
  title09: "แรม 15 ค่ำ",
  title10: "กลางวัน",
  title11: "กลางคืน",
  title12: "อาทิตย์ขึ้น",
  title13: "อาทิตย์ตก",
  title14: "ดวงจันทร์ขึ้น",
  title15: "ดวงจันทร์ตก",
  title16: "แหล่งข้อมูล",
  title17: "เริ่ม",
  title18: "สิ้นสุด",
  title19: "ใช้ตำแหน่งปัจจุบัน",
  title20: "ค้นหาเมือง",
  title21: "อุณหภูมิที่รู้สึกได้จริง",
  title22: "อุณหภูมิที่รู้สึกได้ในร่ม",
  title23: "ตอนนี้",
  title24: "วันนี้",
  title25: "อาทิตย์",
  title26: "จันทร์",
  title27: "อังคาร",
  title28: "พุธ",
  title29: "พฤหัส",
  title30: "ศุกร์",
  title31: "เสาร์",
  title32: "กำลังโหลด...",
  title33: "ตอนนี้",
  title34: "รายชั่วโมง",
  title35: "รายวัน",
  title36: "ดวงอาทิตย์ & ดวงจันทร์",
  title37: "คุณภาพอากาศ",
  title38: "ติดต่อ: xlf550402@gmail.com",
  title39: "ข้อตกลงความเป็นส่วนตัว",
  title40: "Copyright © comfortweather.com 2020 - 2026. All Rights Reserved.",
  title41: "ข้อมูลโดย",
  title42: "สูง",
  title43: "ต่ำ",
  title44: "ยอมรับ",
  title45: "ขอบคุณที่ใช้ ComfortWeather และเพื่อปกป้องสิทธิ์ทางกฎหมายและผลประโยชน์ของคุณ โปรดอ่าน ",
  title46: "นโยบายความเป็นส่วนตัว",
  title47: " อย่างละเอียดก่อนใช้งาน",
  title48: "",
  title49: "ติดต่อ: xyjph123@gmail.com",
  title50: "Copyright © 24hweather.com 2020 - 2026. All Rights Reserved.",
  title51: "ขอบคุณที่ใช้ 24hweather และเพื่อปกป้องสิทธิ์ทางกฎหมายและผลประโยชน์ของคุณ โปรดอ่าน ",
  title52: "โลเคชั่นของคุณมีการเปลี่ยนแปลง ต้องการอัพเดตหรือไม่?",
  title53: "ตกลง",
  title54: "ยกเลิก",
  title55: "ย้อนกลับ",
  title56: "ข่าว",
  title57: "กำลังอัพเดตสภาพอากาศ…",
  title58: "อัพเดตสภาพอากาศแล้ว",
  title59: "ดูทั้งหมด",
  title60: "Copyright © mobi321.com 2020 - 2026. All Rights Reserved.",
  title61: "เมื่อวานนี้",
  title62: "วันพรุ่งนี้",
  title63: "พยากรณ์อากาศใน 15 วัน",
  title64: "รายละเอียดของวันนี้",
  title65: "Rahu Kaal",
  title66: "ดัชนีไลฟ์สไตล์",
  title67: "ดัชนีไลฟ์สไตล์",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "ตากแห้งยาก",
  title103: "แห้งช้า",
  title104: "แห้งได้ดี",
  title105: "แห้งเร็ว",
  title106: "แห้งเร็วมาก",

  title107: "ไม่เหมาะสม",
  title108: "พอใช้ได้",
  title109: "เหมาะสำหรับกิจกรรมทางน้ำ",
  title110: "เหมาะสมมาก",
  title111: "สภาพอากาศสมบูรณ์แบบ",

  title112: "ส่งเสริมต่อสุขภาพ",
  title113: "สภาวะเป็นกลาง",
  title114: "มีความเสี่ยงสูงขึ้นเล็กน้อย",
  title115: "ความเสี่ยงสูง",
  title116: "ความเสี่ยงสูงมาก",

  title117: "ไม่เหมาะสม",
  title118: "ค่อนข้างเหมาะสม",
  title119: "เหมาะสำหรับกิจกรรมกลางแจ้ง",
  title120: "เหมาะสมมาก",
  title121: "สภาพอากาศยอดเยี่ยม",

  title122: "ผิวแห้งมาก",
  title123: "มีแนวโน้มผิวแห้ง",
  title124: "ผิวแห้งเล็กน้อย",
  title125: "ไม่ค่อยมีแนวโน้มผิวแห้ง",
  title126: "แทบไม่มีโอกาสผิวแห้ง",

  title127: "ไม่แนะนำ",
  title128: "พอใช้ได้",
  title129: "วันที่เหมาะสม",
  title130: "สภาพอากาศดีมาก",
  title131: "สภาพอากาศเหมาะสมที่สุด",
};
